import * as Effects from 'redux-saga/effects'
import { ActionPattern, cancel, fork, spawn, take } from 'redux-saga/effects'
import { clearRoomId } from '../../actions/bookingCalendar/roomModal/toggleRoomModal'
import { ICloseModal } from '../../actions/Modals/closeModal'
import { IOpenModal } from '../../actions/Modals/openModal'
import { Modals } from '../../containers/Modals/ModalContainer'
import { ModalActions } from '../../reducers/modals/actionNames'
import createRoomModal from './createRoomModal'
import templateSendModal from './templateSendModal'
import {
  getUserScope,
  getWorkerId,
} from '../../reducers/userAccount/selectors/userAccount'
import { PermissionScope } from '../../containers/Employees'
import { fireToastError } from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import { Mixpanel } from '../../utils/Mixpanel'

function* modalsOpen(action: IOpenModal) {
  let userScopes: any = null

  const workerId = yield Effects.select(getWorkerId)

  switch (action.id) {
    case Modals.TemplateSendModal:
      yield Effects.put({ ...action, type: ModalActions.OpenModalRedux })
      return yield* templateSendModal()
    case Modals.EditReservation:
      userScopes = yield Effects.select(getUserScope)

      const allowReservationEdit = (userScopes || []).some(
        s => s === PermissionScope.SCOPE_CAN_VIEW_RESERVATIONS,
      )

      if (allowReservationEdit) {
        yield Effects.put({ ...action, type: ModalActions.OpenModalRedux })
      } else {
        Mixpanel.track('Employee Access Denied', {
          'Employee ID': workerId,
        })
        yield Effects.put(fireToastError(i18n.t('BED_3621_no_permission')))
      }
      break

    case Modals.AddReservation:
      userScopes = yield Effects.select(getUserScope)

      const allowReservationAdd = (userScopes || []).some(
        s => s === PermissionScope.SCOPE_CAN_VIEW_RESERVATIONS,
      )

      if (allowReservationAdd) {
        yield Effects.put({ ...action, type: ModalActions.OpenModalRedux })
      } else {
        Mixpanel.track('Employee Access Denied', {
          'Employee ID': workerId,
        })
        yield Effects.put(fireToastError(i18n.t('BED_3621_no_permission')))
      }
      break

    case Modals.EditRoom:
      userScopes = yield Effects.select(getUserScope)

      const allowRoomEdit = (userScopes || []).some(
        s => s === PermissionScope.SCOPE_CAN_EDIT_ROOMS,
      )

      if (allowRoomEdit) {
        yield Effects.put({ ...action, type: ModalActions.OpenModalRedux })
      } else {
        Mixpanel.track('Employee Access Denied', {
          'Employee ID': workerId,
        })
        yield Effects.put(fireToastError(i18n.t('BED_3621_no_permission')))
      }

      return yield Effects.put(clearRoomId())
    case Modals.AddRoom:
      userScopes = yield Effects.select(getUserScope)

      const allowRoomAdd = (userScopes || []).some(
        s => s === PermissionScope.SCOPE_CAN_EDIT_ROOMS,
      )

      if (allowRoomAdd) {
        yield Effects.put({ ...action, type: ModalActions.OpenModalRedux })
      } else {
        Mixpanel.track('Employee Access Denied', {
          'Employee ID': workerId,
        })
        yield Effects.put(fireToastError(i18n.t('BED_3621_no_permission')))
      }

      return yield Effects.put(clearRoomId())
    default:
      return yield Effects.put({ ...action, type: ModalActions.OpenModalRedux })
  }
}

function* modalsClose(action: ICloseModal) {
  switch (action.id) {
    case Modals.EditRoom:
      return yield Effects.put(clearRoomId())
    case Modals.AddRoom:
      return yield Effects.put(clearRoomId())
  }
}

function* preModalsOpen(action: IOpenModal) {
  try {
    switch (action.id) {
      case Modals.AddRoom:
        yield Effects.call(createRoomModal)
    }

    yield Effects.put({
      ...action,
      type: ModalActions.OpenModal,
    })
  } catch (e) {}
}

function takeLatestForModalId() {
  const spawned = {}
  return function(pattern: ActionPattern, sagaToRun: any) {
    return spawn(function*() {
      while (true) {
        const taskAction = yield take(pattern)

        if (spawned[taskAction.id]) {
          yield cancel(spawned[taskAction.id])
        }
        if (taskAction) {
          spawned[taskAction.id] = yield fork(sagaToRun, taskAction)
        }
      }
    })
  }
}

export default function*() {
  yield Effects.takeEvery(ModalActions.OpenModal, modalsOpen)
  yield Effects.takeEvery(ModalActions.CloseModal, modalsClose)
  yield takeLatestForModalId()(ModalActions.RequestOpenModal, preModalsOpen)
}
